export const smilies = [
	[[':hooray:'], 'D83CDF89.png'],
	[[':thinking:'], 'D83EDD14.png'],
	[[':scope:'], 'D83DDD2E.png'],

	[[':idea:'], 'idea.gif'],
	[[':lol:'], 'lol.gif'],
	[[':mrgreen:'], 'mrgreen.gif'],
	[[':roll:'], 'rolleyes.gif'],
	[[':like:'], 'like.png'],
	[[':!:'], 'exclaim.gif'],
	[[':?:'], 'question.gif'],

	[['<3'], 'heart.png'],
	[['=>'], 'arrow.gif'],
	[['<='], 'rarrow.gif'],
	[[':?', ':-?'], 'confused.gif'],
	[['8)', '8-)'], 'cool.gif'],
	[[':\'('], 'cry.gif'],
	[['O_O', 'O_o', 'o_O'], 'eek.gif'],
	[['>:(', '>:-('], 'evil.gif'],
//		[[''], 'frown.gif'],
	[[':|', ':-|'], 'neutral.gif'],
	[[':p', ':P', ':-p', ':-P'], 'razz.gif'],
	[[':$', ':-$'], 'redface.gif'],
	[[':(', ':-(', '=('], 'sad.gif'],
	[[':)', ':-)', '=)'], 'smile.gif'],
	[[':O', ':o', ':-O', ':-o'], 'surprised.gif'],
	[['>:D', '>:-D'], 'twisted.gif'],
	[[':D', ':-D'], 'biggrin.gif'],
	[[';)', ';-)'], 'wink.gif'],
	[['D:'], 'mad.gif'],
];

export let smileMap = {};
export let smileCodes = [];

for (let i in smilies){
	let s = smilies[i];
	for (let j in s[0]){
		let smile = s[0][j];
		smileMap[smile] = s[1];
		smileCodes.push(smile);
	}
}

export let smileRegex = new RegExp('^(' + smileCodes.map(RegExp.escape).join('|') + ')', 'g');
